export const NO_AVATAR_SUFFIX = 'user_X50.png';
